export default {
  zIndex: '9',
  minHeight: '76px',
  stickyTop: 'var(--nav-checkout-height)',
};
